export { DEFAULT_PAGE_SIZE } from 'hooks/useSelectPanelField/constants';

export const FIELD_BOUNDARIES_PAGE_SIZE = 100;
